import React from "react";
import PropTypes from "prop-types";
//Material imports
import ListSubheader from "@mui/material/ListSubheader";
import withStyles from "@mui/styles/withStyles";
const PanelHeader = ({
  classes,
  children,
  borderBottom = true
}) => {
  return /*#__PURE__*/React.createElement(ListSubheader, {
    className: classes.rootContainer,
    style: {
      borderBottom: !borderBottom && "0"
    },
    component: "div"
  }, children);
};
const styles = {
  rootContainer: {
    display: "flex",
    height: 67,
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "2px solid rgba(0, 0, 0, 0.3)",
    alignItems: "center",
    padding: 0,
    backgroundColor: "transparent"
  }
};
export default withStyles(styles)(PanelHeader);
PanelHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  borderBottom: PropTypes.bool
};